/*
 * Public API Surface of ionic
 */

export * from './lib/ui-ionic';
